"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("block/base");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var Container =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(Container, _BlockContainer);

  function Container() {
    babelHelpers.classCallCheck(this, Container);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Container).apply(this, arguments));
  }

  return Container;
}(_base.BlockContainer);

exports.default = Container;